"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingContainer = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const hooks_1 = require("../../hooks");
const LoadingContainer = (_a) => {
    var { loading, children, spinnerSize = 'xl', showSpinner = true } = _a, props = __rest(_a, ["loading", "children", "spinnerSize", "showSpinner"]);
    const { primaryColor } = (0, hooks_1.usePrimaryColor)();
    return loading ? (react_2.default.createElement(react_1.Flex, Object.assign({ width: "100%", height: "full", textAlign: "center", margin: 'auto', alignItems: "center", justifyContent: "center", paddingBottom: 2 }, props),
        react_2.default.createElement(react_1.Spinner, { thickness: "3px", speed: "1s", emptyColor: "gray.200", color: primaryColor, size: spinnerSize, hidden: !showSpinner }))) : (react_2.default.createElement(react_2.default.Fragment, null, children));
};
exports.LoadingContainer = LoadingContainer;
//# sourceMappingURL=LoadingContainer.js.map